















































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator'
import AbpBase from '../../../lib/abpbase'
import serachmember from '@/store/entities/wm/searchworklogmember'
import Util from '../../../lib/util'
import { ElTable } from 'element-ui/types/table'
import ItemTrees from '@/store/entities/jm/itemtree'
@Component
export default class SeracgCreateLogMember extends AbpBase {
  @Prop({ type: Boolean, default: false }) value: boolean
  serachmember: serachmember = new serachmember()
  ItemTrees: Array<ItemTrees> = new Array<ItemTrees>()
  logmembers: Array<any> = []
  oldlogmembers: Array<any> = []
  count = 0

  get memberlist() {
    return this.$store.state.worklog.memberitem
  }
  get loading() {
    return this.$store.state.worklog.loading
  }

  //跟新数据选中传递过来的标签
  async initData(data, logdata) {
    if (logdata.length > 0) {
      let memtable = this.$refs.product as any
      data.forEach((item) => {
        item.isSelect = false // 设置默认为不选中

        // 检查当前 item 是否在 this.logmembers 中
        logdata.forEach((logMember) => {
          if (logMember.userId == item.userId) {
            // 选中节点
            memtable.toggleRowSelection(item, true)
            this.selectFun(null, item)
          }
        })

        // 递归处理子节点
        if (item.children && item.children.length) {
          this.initData(item.children, logdata)
        }
      })
    }
  }
  selectFun(selection, row) {
    /**
     * 获取所有末级节点
     * @param {*} obj
     */
    function getLeafNodes(obj) {
      let leafNodes = []

      /**
       * 获取要添加到tag的数据，并去重
       * @param {*} node
       */
      function traverse(node) {
        if ((!node.children || node.children.length === 0) && node.id.indexOf('L') !== -1) {
          if (node.isSelect == true && leafNodes.every((e) => e.userId != node.userId)) {
            leafNodes.push(node)
          }
        } else {
          node.children.forEach((child) => {
            traverse(child)
          })
        }
      }

      obj.forEach((item) => {
        traverse(item)
      })

      return leafNodes
    }
    this.setRowIsSelect(row)

    // 获取所有末级节点
    if (this.serachmember.username == '') {
      this.logmembers = getLeafNodes(this.memberlist)
    } else {
      this.getmemlistcheck(this.memberlist)
    }
    this.oldlogmembers.forEach((item) => {
      if (!this.logmembers.some((list) => list.userId == item.userId)) {
        this.logmembers.push({ id: item.id, label: item.label, userId: item.userId })
      }
    })
  }
  getmemlistcheck(data) {
    if (data.length > 0) {
      data.forEach((item) => {
        if (!this.logmembers.some((list) => list.userId == item.userId) && item.userId != null) {
          if (item.isSelect) {
            if (!this.logmembers.some((list) => list.userId == item.userId)) {
              this.logmembers.push({ id: item.id, label: item.label, userId: item.userId })
            }
          } else {
            let num
            for (let i = 0; i < this.logmembers.length; i++) {
              if (this.logmembers[i].userId == item.userId) {
                num = i
              }
            }
            if (this.logmembers.some((list) => list.userId == item.userId)) {
              this.logmembers.splice(num, 1)
            }
          }
        } else if (this.logmembers.some((list) => list.userId == item.userId) && item.userId != null) {
          if (item.isSelect) {
            if (!this.logmembers.some((list) => list.userId == item.userId)) {
              this.logmembers.push({ id: item.id, label: item.label, userId: item.userId })
            }
          } else {
            let num
            for (let i = 0; i < this.logmembers.length; i++) {
              if (this.logmembers[i].userId == item.userId) {
                num = i
              }
            }
            if (this.logmembers.some((list) => list.userId == item.userId)) {
              this.logmembers.splice(num, 1)
            }
          }
        }
        if (item.children && item.children.length) {
          this.getmemlistcheck(item.children)
        }
      })
    }
  }
  setRowIsSelect(row) {
    const tableRef = this.$refs.product as any
    //当点击父级点复选框时，当前的状态可能为未知状态，所以当前行状态设为false并选中，即可实现子级点全选效果
    if (row.isSelect === '') {
      row.isSelect = false
      tableRef.toggleRowSelection(row, true)
    }
    row.isSelect = !row.isSelect
    let that = this

    /**
     * 设置相同的子级节点为选中状态，此方法对应的中级节点和根节点，中级节点指的是即有上级又有下级的节点
     * @param {*} data
     */
    function selectAllChildrens(data) {
      let leafNodes = []

      /**
       * 内部递归
       * @param {} sub
       */
      function selectChildrens(sub) {
        sub.forEach((item) => {
          if (item.children && item.children.length) {
            item.isSelect = row.isSelect
            tableRef.toggleRowSelection(item, row.isSelect)
            selectChildrens(item.children)
          } else {
            //末级节点
            leafNodes.push(item)
            //设置相同userId的末级节点为选中状态
            setSameNameNodes(item.userId)
          }
        })
      }

      selectChildrens(data)

      return leafNodes
    }

    function getSelectStatus(selectStatuaArr, data) {
      data.forEach((childrenItem) => {
        selectStatuaArr.push(childrenItem.isSelect)
        if (childrenItem.children && childrenItem.children.length) {
          getSelectStatus(selectStatuaArr, childrenItem.children)
        }
      })
      return selectStatuaArr
    }

    function getLevelStatus(row) {
      //如果当前节点的parantId =0 并且有子节点，则为1
      //如果当前节点的parantId !=0 并且子节点没有子节点 则为3
      if (row.parentId == 0) {
        if (row.children && row.children.length) {
          return 1
        } else {
          return 4
        }
      } else {
        if (!row.children || !row.children.length) {
          return 3
        } else {
          return 2
        }
      }
    }

    let result = new ItemTrees()
    /**
     * 获取明确的节点
     * @param {*} data
     * @param {*} parentId
     */
    function getExplicitNode(data, parentId) {
      data.forEach((item) => {
        if (item.id == parentId) {
          result = item
        }
        if (item.children && item.children.length) {
          getExplicitNode(item.children, parentId)
        }
      })
      return result
    }

    /**
     * 设置父节点状态为：不选|半选|全选
     * @param {*} row
     */
    function operateLastLeve(row) {
      //操作的是子节点  1、获取父节点  2、判断子节点选中个数，如果全部选中则父节点设为选中状态，如果都不选中，则为不选中状态，如果部分选择，则设为不明确状态
      let selectStatuaArr = []
      let item = getExplicitNode(that.memberlist, row.parentId)
      selectStatuaArr = getSelectStatus(selectStatuaArr, item.children)

      if (
        selectStatuaArr.every((selectItem) => {
          return true == selectItem
        })
      ) {
        item.isSelect = true

        tableRef.toggleRowSelection(item, true)
      } else if (
        selectStatuaArr.every((selectItem) => {
          return false == selectItem
        })
      ) {
        item.isSelect = false

        tableRef.toggleRowSelection(item, false)
      } else {
        item.isSelect = ''
      }
      //则还有父级
      if (item.parentId != '0') {
        operateLastLeve(item)
      }
    }

    /**
     * 根据传入的name设置同名节点为选中状态
     * @param {*} obj 遍历的整棵树
     * @param {*} userId 要查找的用户ID
     */
    function setSameNameNodes(userId) {
      let leafNodes = []

      function traverse(node) {
        if (!node.children || node.children.length === 0) {
          if (node.userId == userId) {
            leafNodes.push(node)
            var status = row.isSelect
            tableRef.toggleRowSelection(node, status)
            node.isSelect = status
          }
        } else {
          node.children.forEach((child) => {
            traverse(child)
          })
        }
      }

      tableRef.data.forEach((item) => {
        traverse(item)
      })

      return leafNodes
    }

    /**
     * 根据传入的name获取同名节点
     * @param {*} obj 遍历的整棵树
     * @param {*} userId 要查找的用户节点
     */
    function getSameNameNodes(userId) {
      let leafNodes = []

      function traverse(node) {
        if (!node.children || node.children.length === 0) {
          if (node.userId == userId) {
            leafNodes.push(node)
          }
        } else {
          node.children.forEach((child) => {
            traverse(child)
          })
        }
      }

      tableRef.data.forEach((item) => {
        traverse(item)
      })

      return leafNodes
    }

    //判断操作的是子级点复选框还是父级点复选框，如果是父级点，则控制子级点的全选和不全选

    //1、只是父级 2、既是子集，又是父级 3、只是子级
    let levelSataus = getLevelStatus(row)

    //下面三种情况分别做了修改，分别对应根节点、中级级别和末级节点
    if (levelSataus == 1) {
      //根节点为与中级节点处理方法相同
      var subnodes = selectAllChildrens(row.children)
      subnodes.forEach((n) => {
        var sameNodes = getSameNameNodes(n.userId)
        sameNodes.forEach((s) => {
          operateLastLeve(s)
        })
        //operateLastLeve(s)
      })
    } else if (levelSataus == 2) {
      //中级节点需要先直接设置同名节点，然后获取要设置的中级节点，再调用getSameNameNodes获取每一个中级节点的子节点同名节点，并遍历修改其父级状态
      var nodes = selectAllChildrens(row.children)
      nodes.forEach((n) => {
        var sameNodes = getSameNameNodes(n.userId)
        sameNodes.forEach((s) => {
          operateLastLeve(s)
        })
      })
      //operateLastLeve(row)
    } else if (levelSataus == 3) {
      //末级节点最简单，直接设置同名节点，然后获取所有要设置状态的同名节点，遍历修改其父级状态即可
      var child = setSameNameNodes(row.userId)
      child.forEach((x) => {
        operateLastLeve(x)
      })
    }
  }
  checkIsAllSelect() {
    let oneProductIsSelect = []
    this.memberlist.forEach((item) => {
      oneProductIsSelect.push(item.isSelect)
    })
    //判断一级产品是否是全选.如果一级产品全为true，则设置为取消全选，否则全选
    let isAllSelect = oneProductIsSelect.every((selectStatusItem) => {
      return true == selectStatusItem
    })
    return isAllSelect
  }
  selectAllFun(selection) {
    const tableRef = this.$refs.product as any
    let isAllSelect = this.checkIsAllSelect()
    this.memberlist.forEach((item) => {
      item.isSelect = isAllSelect
      tableRef.toggleRowSelection(item, !isAllSelect)
      this.selectFun(selection, item)
    })
  }
  rowClassNameFun({ row }) {
    if (row.isSelect === '') {
      return 'indeterminate'
    }
  }
  headerRowClassName() {
    let oneProductIsSelect = []
    this.memberlist.forEach((item) => {
      oneProductIsSelect.push(item.isSelect)
    })
    if (oneProductIsSelect.includes('')) {
      return 'indeterminate'
    }
    return ''
  }

  handleClose(tag) {
    const tableRef = this.$refs.product as any
    this.logmembers.splice(this.logmembers.indexOf(tag), 1)
    var _this = this
    function getLeafNodes(obj) {
      let leafNodes = []

      function traverse(node) {
        if (!node.children || node.children.length === 0) {
          if (node.userId == tag.userId) {
            tableRef.toggleRowSelection(node, false)
            node.isSelect = true
            _this.setRowIsSelect(node)
          }
        } else {
          node.children.forEach((child) => {
            traverse(child)
          })
        }
      }

      obj.forEach((item) => {
        traverse(item)
      })

      return leafNodes
    }
    getLeafNodes(this.memberlist)
  }

  save() {
    this.$store.commit('worklog/setmemberliststring', this.logmembers)
    this.logmembers = []
    this.$emit('save-success')
    this.$emit('input', false)
  }

  cancel() {
    this.logmembers = []
    this.serachmember.username = ''
    this.$store.commit('worklog/setoldmemberliststring', this.oldlogmembers)
    this.$emit('cancel-cancellation')
    this.$emit('input', false)
  }
  async created() {}

  async getprotree() {
    this.serachmember.Id = ''
    this.serachmember.Id = this.$store.state.worklog.serachlogmember.Id
    if (this.serachmember.Id == '') {
      this.serachmember.Id = this.$store.state.worklog.guId
    }
    if (!this.serachmember.username) {
      this.serachmember.username = ''
    }
    await this.$store.dispatch({
      type: 'worklog/GetProjectUserTrees',
      data: this.serachmember
    })
    let count = 0
    this.logmembers.forEach((item) => {
      this.oldlogmembers.forEach((item1) => {
        if (item.id == item1.id) {
          count += 1
        }
      })
    })
    if (count == this.memberlist.length) {
      await this.initData(this.memberlist, this.oldlogmembers)
    } else {
      await this.initData(this.memberlist, this.logmembers)
    }
  }
  async visibleChange(value: boolean) {
    if (!value) {
      this.logmembers = []
      this.$emit('input', value)
    } else {
      await this.getprotree()
      this.logmembers = this.$store.state.worklog.memberlist
      this.oldlogmembers = this.$store.state.worklog.oldmemberlist
      await this.initData(this.memberlist, this.$store.state.worklog.memberlist)
    }
  }
}
